import { render, staticRenderFns } from "./surat-jalan-print.vue?vue&type=template&id=23c79ec4&scoped=true&"
import script from "./surat-jalan-print.vue?vue&type=script&lang=js&"
export * from "./surat-jalan-print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c79ec4",
  null
  
)

export default component.exports